import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Spinner} from 'core/uicore';
import {useRouter} from 'core/hooks/useRouter';

export const PrivateRoute = ({isAuthorized, children, ...rest}) => {
  const {isAuthenticated, user, controlItems} = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
    controlItems: state.setupItems.controlItems,
  }));
  const {location} = useRouter();

  if (!isAuthenticated) {
    return <Redirect to={{pathname: '/login', state: {from: location}}} />;
  }
  if (!controlItems) {
    return <Spinner />;
  }
  let defaultApp = '/login';
  if (
    user.system.isNewBusiness &&
    user?.permissions?.isNewBusiness?.isActive &&
    user["defaultApplication"] === "New Business"
  ) {
    defaultApp = "/illustration";
  } else if (
    user.system.isInforce &&
    user?.permissions?.isInforce?.isActive &&
    user["defaultApplication"] === "Inforce"
  ) {
    defaultApp = "/inforce";
  } else if (
    user?.permissions?.isAdmin?.isActive &&
    user["defaultApplication"] === "Admin"
  ) {
    defaultApp = "/admin";
  }
  return (
    <Route
      {...rest}
      render={() =>
        isAuthorized ? children : <Redirect to={{pathname: defaultApp, state: {from: location}}} />
      }
    />
  );
};

export default PrivateRoute;
